export default "__VITE_ASSET__B2LQSX9t__"